module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "debug-options"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "debug-options__content"
  }, [_c('div', {
    staticClass: "debug-section"
  }, [_c('h4', [_vm._v("👥 Add Runners")]), _vm._v(" "), _c('div', {
    staticClass: "debug-form-group"
  }, [_c('label', {
    staticClass: "debug-label"
  }, [_vm._v("Number of Runners:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.totalRunnersTobeAdded),
      expression: "totalRunnersTobeAdded"
    }],
    staticClass: "debug-input",
    attrs: {
      "type": "number",
      "placeholder": "Enter number of runners",
      "min": "1",
      "max": "100"
    },
    domProps: {
      "value": (_vm.totalRunnersTobeAdded)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.totalRunnersTobeAdded = $event.target.value
      }, _vm.clearMessages]
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "debug-buttons"
  }, [_c('button', {
    staticClass: "debug-btn debug-btn--primary",
    attrs: {
      "disabled": _vm.loading
    },
    on: {
      "click": _vm.onAddRunners
    }
  }, [(_vm.loading) ? _c('span', [_vm._v("Adding...")]) : _c('span', [_vm._v("Add Runners")])]), _vm._v(" "), _c('button', {
    staticClass: "debug-btn debug-btn--success",
    attrs: {
      "disabled": !_vm.runnerExist || _vm.runnerExistinFB
    },
    on: {
      "click": _vm.onAddtoFirebase
    }
  }, [_vm._v("\n          Join Race\n        ")])]), _vm._v(" "), (_vm.hasAdded) ? _c('div', {
    staticClass: "debug-alert debug-alert--success"
  }, [_vm._v("\n        " + _vm._s(_vm.hasAdded) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.hasError) ? _c('div', {
    staticClass: "debug-alert debug-alert--error"
  }, [_vm._v("\n        " + _vm._s(_vm.hasError) + "\n      ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "debug-section"
  }, [_c('h4', [_vm._v("🎛️ Speed Control")]), _vm._v(" "), _c('div', {
    staticClass: "debug-form-group"
  }, [_c('label', {
    staticClass: "debug-label"
  }, [_vm._v("Update Speed (ms): " + _vm._s(_vm.duration))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.duration),
      expression: "duration"
    }],
    staticClass: "debug-slider",
    attrs: {
      "type": "range",
      "min": "500",
      "max": "5000",
      "step": "100"
    },
    domProps: {
      "value": (_vm.duration)
    },
    on: {
      "__r": function($event) {
        _vm.duration = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "debug-buttons"
  }, [_c('button', {
    staticClass: "debug-btn debug-btn--success",
    attrs: {
      "disabled": !_vm.runnerExistinFB || _vm.isRunning
    },
    on: {
      "click": _vm.startSimulation
    }
  }, [_vm._v("\n          ▶️ Start Simulation\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "debug-btn debug-btn--danger",
    attrs: {
      "disabled": !_vm.isRunning
    },
    on: {
      "click": _vm.stopSimulation
    }
  }, [_vm._v("\n          ⏹️ Stop Simulation\n        ")])]), _vm._v(" "), (_vm.isRunning) ? _c('div', {
    staticClass: "debug-alert debug-alert--info"
  }, [_vm._v("\n        Simulation running... Updates every " + _vm._s(_vm.duration) + "ms\n      ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "debug-section"
  }, [_c('h4', [_vm._v("📊 Race Status")]), _vm._v(" "), _c('div', {
    staticClass: "debug-info"
  }, [_c('div', {
    staticClass: "debug-info-item"
  }, [_c('span', {
    staticClass: "debug-label"
  }, [_vm._v("Race ID:")]), _vm._v(" "), _c('span', {
    staticClass: "debug-value"
  }, [_vm._v(_vm._s(_vm.$route.params.raceId))])]), _vm._v(" "), _c('div', {
    staticClass: "debug-info-item"
  }, [_c('span', {
    staticClass: "debug-label"
  }, [_vm._v("Race Status:")]), _vm._v(" "), _c('span', {
    staticClass: "debug-value",
    class: _vm.getStatusClass()
  }, [_vm._v(_vm._s(_vm.raceStatus))])]), _vm._v(" "), _c('div', {
    staticClass: "debug-info-item"
  }, [_c('span', {
    staticClass: "debug-label"
  }, [_vm._v("Subscribed Runners:")]), _vm._v(" "), _c('span', {
    staticClass: "debug-value"
  }, [_vm._v(_vm._s(_vm.subscribedRunners))])]), _vm._v(" "), _c('div', {
    staticClass: "debug-info-item"
  }, [_c('span', {
    staticClass: "debug-label"
  }, [_vm._v("Simulation Status:")]), _vm._v(" "), _c('span', {
    staticClass: "debug-value",
    class: _vm.isRunning ? 'debug-value--active' : 'debug-value--inactive'
  }, [_vm._v("\n            " + _vm._s(_vm.isRunning ? 'Running' : 'Stopped') + "\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "debug-info-item"
  }, [_c('span', {
    staticClass: "debug-label"
  }, [_vm._v("Current Time:")]), _vm._v(" "), _c('span', {
    staticClass: "debug-value"
  }, [_vm._v(_vm._s(_vm.currentTime))])])])]), _vm._v(" "), _c('div', {
    staticClass: "debug-section"
  }, [_c('h4', [_vm._v("🔥 Firebase Status")]), _vm._v(" "), _c('div', {
    staticClass: "debug-info"
  }, [_c('div', {
    staticClass: "debug-info-item"
  }, [_c('span', {
    staticClass: "debug-label"
  }, [_vm._v("Runners in DB:")]), _vm._v(" "), _c('span', {
    staticClass: "debug-value",
    class: _vm.runnerExist ? 'debug-value--active' : 'debug-value--inactive'
  }, [_vm._v("\n            " + _vm._s(_vm.runnerExist ? 'Yes' : 'No') + "\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "debug-info-item"
  }, [_c('span', {
    staticClass: "debug-label"
  }, [_vm._v("Runners in Firebase:")]), _vm._v(" "), _c('span', {
    staticClass: "debug-value",
    class: _vm.runnerExistinFB ? 'debug-value--active' : 'debug-value--inactive'
  }, [_vm._v("\n            " + _vm._s(_vm.runnerExistinFB ? 'Yes' : 'No') + "\n          ")])])]), _vm._v(" "), _c('div', {
    staticClass: "debug-buttons",
    staticStyle: {
      "margin-top": "1rem"
    }
  }, [_c('a', {
    staticClass: "debug-btn debug-btn--info",
    attrs: {
      "href": _vm.firebaseConsoleUrl,
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("\n          🔗 View in Firebase\n        ")])]), _vm._v(" "), (_vm.hasAddedToFB) ? _c('div', {
    staticClass: "debug-alert debug-alert--success"
  }, [_vm._v("\n        " + _vm._s(_vm.hasAddedToFB) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.hasErrorToFB) ? _c('div', {
    staticClass: "debug-alert debug-alert--error"
  }, [_vm._v("\n        " + _vm._s(_vm.hasErrorToFB) + "\n      ")]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "debug-options__header"
  }, [_c('h3', [_vm._v("🏃 Race Simulator")]), _vm._v(" "), _c('p', {
    staticClass: "debug-options__subtitle"
  }, [_vm._v("Add Runners & Control Race Simulation")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "debug-speed-labels"
  }, [_c('span', [_vm._v("Fast (500ms)")]), _vm._v(" "), _c('span', [_vm._v("Slow (5000ms)")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-097fb954"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LiveRun/Race/DebugOptions.vue
// module id = 1650
// module chunks = 2